/**
 * DATEPICKER TOKENS
 * Source: 🔧 Custom — not defined in Figma component tokens
 */

import { type SemanticTokens, SEMANTIC } from '../semantic.js';

export function createDatepickerTokens(s: SemanticTokens) {
  return {
  base: {
    padding: s.layout.gap.md,                // --datepicker-base-padding: var(--spacing-16)
    radius: s.radius.md,                     // --datepicker-base-radius: var(--radius-16)
    fontFamily: s.typography.fontFamily.base, // --datepicker-base-font-family
  },
  panel: {
    padding: s.layout.gap.lg,
    bg: s.surface.ground,                    // --datepicker-panel-bg: var(--surface-ground)
    fg: s.text.secondary,                    // --datepicker-panel-fg: var(--text-secondary)
    shadow: s.shadow.card,                   // --datepicker-panel-shadow
    borderColor: s.surface.canvas,           // --datepicker-panel-inline-border-color
  },
  header: {
    bg: 'transparent',                       // --datepicker-header-bg: transparent
    fg: s.text.secondary,                    // --datepicker-header-fg: var(--text-secondary)
    padding: s.layout.gap.sm,                // --datepicker-header-padding
  },
  title: {
    gap: s.layout.gap.lg,                    // --datepicker-title-gap
    fontWeight: s.typography.fontWeight.semibold, // --datepicker-title-font-weight
  },
  date: {
    fg: s.text.secondary,                    // --datepicker-date-fg: var(--text-secondary)
    fgHover: s.text.secondary,               // --datepicker-date-fg-hover
    bgHover: s.surface.canvas,               // --datepicker-date-bg-hover: var(--surface-canvas)
    selectedBg: s.interactive.primary.base,            // --datepicker-date-selected-bg
    selectedFg: s.surface.ground,            // --datepicker-date-selected-fg
    selectedBorder: s.border.primary,      // --datepicker-date-selected-border
    rangeBg: s.surface.canvas,               // --datepicker-date-range-bg (#e7e8ec)
    rangeFg: s.text.secondary,               // --datepicker-date-range-fg
    rangeBorder: s.interactive.secondary.subtle, // --datepicker-date-range-border
    size: s.iconSizes.xl,                    // --datepicker-date-size (width/height)
    radius: s.radius.md,                     // --datepicker-date-radius
    padding: s.layout.padding.xs,            // --datepicker-date-padding
  },
  today: {
    bg: 'transparent',                       // --datepicker-today-bg (default context)
    bgLight: s.interactive.primary.subtlePressed, // --datepicker-today-bg-light (light colorScheme)
    fg: s.text.primary,                      // --datepicker-today-fg
    border: s.surface.canvas,                // --datepicker-today-border (#e7e8ec)
    fontWeight: s.typography.fontWeight.semibold, // --datepicker-today-font-weight
  },
  otherMonth: {
    fg: s.text.muted,                        // --datepicker-other-month-fg
  },
  nav: {
    bg: s.surface.ground,                    // --datepicker-nav-bg
    fg: s.text.secondary,                    // --datepicker-nav-fg
    bgHover: s.interactive.primary.subtle,    // --datepicker-nav-bg-hover
    bgActive: s.interactive.primary.subtlePressed, // --datepicker-nav-bg-active
    fgHover: s.text.primary,                 // --datepicker-nav-fg-hover
    padding: s.radius.sm,                    // --datepicker-nav-padding
    radius: s.radius.sm,                     // --datepicker-nav-radius
  },
  dropdown: {
    bg: 'transparent',                       // --datepicker-dropdown-bg: transparent
    bgHover: 'transparent',                  // --datepicker-dropdown-bg-hover: transparent
    bgActive: 'transparent',                 // --datepicker-dropdown-bg-active: transparent
    fg: s.text.muted,                        // --datepicker-dropdown-fg: var(--text-muted)
    fgHover: s.text.secondary,               // --datepicker-dropdown-fg-hover
    fgActive: s.text.secondary,              // --datepicker-dropdown-fg-active
    size: s.iconSizes.lg,                    // --datepicker-dropdown-size
    radius: s.radius.sm,                     // --datepicker-dropdown-radius
  },
  rangeDay: {
    fontWeight: s.typography.fontWeight.normal
  },
  weekDay: {
    fg: s.text.secondary,                    // --datepicker-weekday-fg
    padding: s.layout.padding.xs,            // --datepicker-weekday-padding
    fontWeight: s.typography.fontWeight.semibold, // --datepicker-weekday-font-weight
  },
  day: {
    size: '2.5rem',                          // --datepicker-day-size
    fontWeight: '500',                       // --datepicker-day-font-weight
    borderWidth: '2px',                      // --datepicker-day-border-width
    transition: '0.2s',                      // --datepicker-day-transition
  },
  month: {
    radius: s.radius.md,                     // --datepicker-month-radius
    padding: s.layout.padding.xs,            // --datepicker-month-padding
  },
  timePicker: {
    gap: s.layout.padding.xs,                // --datepicker-time-picker-gap
    padding: s.layout.padding.sm,            // --datepicker-time-picker-padding (section top)
  },
  inputIcon: {
    fg: s.text.secondary,                    // --datepicker-input-icon-fg
  },
  border: {
    default: s.surface.canvas,               // --datepicker-border-default
  }
  };
}
export const datepickerTokens = createDatepickerTokens(SEMANTIC);